module.exports = __webpack_public_path__ + "static/media/Hero-bg.2ef818d7.jpg";